import { render, staticRenderFns } from "./BinderTemplateStructure.vue?vue&type=template&id=201149d5&"
import script from "./BinderTemplateStructure.vue?vue&type=script&lang=js&"
export * from "./BinderTemplateStructure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports